import { Typography, Grid, InputLabel, FormControl } from '@mui/material'
import { useForm } from 'react-hook-form'
import { UsState } from '@generatedTypes/graphql'
import FormInputSelect from '@components/forms/FormInputSelect'
import FormInputText from '@components/forms/FormInputText'

interface StateCountySelectProps {
  states: UsState[]
  selectedState?: string
  onChange: (state?: string, county?: string) => void
}

interface DataProps {
  state?: string
  county?: string
}

const StateCountySelect: React.FC<StateCountySelectProps> = ({
  states,
  selectedState,
  onChange,
}) => {
  const { control, watch, register } = useForm<DataProps>({
    defaultValues: {
      state: selectedState || '',
      county: '',
    },
  })

  const selectedFormState = watch('state')
  const selectedFormCounty = watch('county')

  register('state', {
    onChange: (e) => {
      onChange(e.target.value, selectedFormCounty)
    },
  })

  register('county', {
    onChange: (e) => {
      onChange(selectedFormState, e.target.value)
    },
  })

  const stateOptions =
    states?.map(({ code, name }) => ({
      label: name,
      value: code,
    })) || []

  return (
    <>
      <Typography>
        Please select the state and county in which the legal matter will be
        created
      </Typography>
      <Typography mt={2} mb={2}>
        Based on your selection, the legal matter will be assigned to legal
        firms registered in that state
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth>
            <InputLabel id="state-label">State</InputLabel>
            <FormInputSelect
              name="state"
              label="State"
              control={control}
              optionItems={stateOptions}
              selectedItem={selectedState}
              data-testid="state-select-id"
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={8} data-testid="country-input">
          <FormInputText
            name="county"
            control={control}
            label="County"
            fullWidth
          />
        </Grid>
      </Grid>
    </>
  )
}

export default StateCountySelect
